import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { SessionDto } from '@/types/dto';

export function useSession() {
  return useQuery({
    queryKey: ['session'],
    queryFn: () => api.get<SessionDto>('/api/session'),
    staleTime: 30_000,
    retry: false,
  });
}
